/// <reference path="../../services/command.service.js" />
/// <reference path="../../services/command-execution.service.js" />
const mod = require('../../bahabot.module.js')

function bbCommandExecutionsController(CommandService, CommandExecutionService, $routeParams) {
    this.execSvc = CommandExecutionService;
    this.params = $routeParams;
    this.loading = false;
    this.command = null;
    this.error = null;
    this.executions = [];

    this.execSvc.reset();
    this.execSvc.filters.commandId = this.params.commandId;
    this.execSvc.fetch();

    const init = () => {
        this.loading = true;
        CommandService.get($routeParams.commandId)
            .catch(e => {
                this.error = e.data.error;
            })
            .then(r => {
                this.command = r;
            })
            .finally(() => {
                this.loading = false;
            })
    }

    init();
}

mod.component('bbCommandExecutions', {
    templateUrl: 'tpl/bb-command-executions.component.html',
    controller: ["CommandService", "CommandExecutionService", "$routeParams", bbCommandExecutionsController],
});